<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg5"
                  src="@/assets/images/wallet.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-primary">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg6"
                  src="@/assets/images/money.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-secondary">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg5"
                  src="@/assets/images/wallet.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-success">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg6"
                  src="@/assets/images/money.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-warning">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg5"
                  src="@/assets/images/wallet.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-info">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg6"
                  src="@/assets/images/money.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-danger">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg6"
                  src="@/assets/images/money.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx outline-badge-dark">
          <div class="vs-card--content">
            <div class="lg:flex">
              <div class="my-auto">
                <img
                  key="onlineImg6"
                  src="@/assets/images/money.png"
                  alt="user-img"
                  width="48"
                  class="mx-2"
                />
              </div>
              <div class="lg:px-3">
                <span class="mb-0 font-semibold h5">Lorem ipsum dolor sit</span>
                <br />
                <p
                  class="mb-0"
                >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis.</p>
              </div>
              <div class="my-auto mt-2 lg:mt-0">
                <vs-button color="primary" class="whitespace-no-wrap" type="border">Get More</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-col>
      
    </div>
  </div>
</template>
<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    Carousel,
    Slide,
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>
